import http from "../../http";

const equity = {
    selectByCompanyId(r) {
        return http.spin.get("/gateway/api/sycompany/pc/CompanyEquityPC/selectByCompanyId", r)
    },
    saveEquity(r) {
        return http.payload("/gateway/api/sycompany/pc/CompanyEquityPC/saveEquity", r)
    },
    delete(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/CompanyEquityPC/delete", r)
    },
    selectById(r) {
        return http.spin.get("/gateway/api/sycompany/pc/CompanyEquityPC/selectById", r)
    },
    bindGoodsList(r) {
        return http.spin.payload("/gateway/api/sycompany/pc/CompanyEquityGoodsPC/bindGoodsList", r)
    },
    saveGoods(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/CompanyEquityGoodsPC/saveGoods", r)
    },
    deleteGoods(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/CompanyEquityGoodsPC/delete", r)
    },
    selectByEquityGoodsList(r) {
        return http.spin.get("/gateway/api/sycompany/pc/CompanyEquityGoodsPC/selectByEquityList", r)
    },
    getNotBindGoodsList(r) {
        return http.spin.get("/gateway/api/sycompany/pc/CompanyEquityGoodsPC/getNotBindGoodsList", r)
    },
    selectUserEquityPage(r) {
        return http.spin.get("/gateway/api/sycompany/pc/CompanyEquityPC/selectUserEquityPage", r)
    },
    activeUserEquity(r) {
        return http.spin.payload("/gateway/api/sycompany/pc/CompanyEquityPC/activeUserEquity", r)
    },
}
export default equity
